export default __webpack_public_path__ + "static/area-bump-bbd95800d4f269a4b31bbe88319f958f.png";